// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"e5ef0705","396":"d6d6b08d","599":"5fa45218","744":"d12c8928","748":"f8270f9c","832":"0e2695d8"}[chunkId] + ".chunk.js";
};